import { useTranslation } from 'react-i18next'

import ErrorIcon from '@/presentation/assets/svg/ErrorIcon.svg'
import Button from '@/presentation/components/Button'
import Header from '@/presentation/components/Header'
import { ROUTES } from '@/services/constants/routes'
import useNavigateWithOrderCode from '@/services/hooks/useNavigateWithOrderCode'

const DivergenceErrorPage: React.FC = () => {
  const { t } = useTranslation()

  const navigate = useNavigateWithOrderCode()

  const handleHomeClick = () => navigate(ROUTES.MAIN)

  const handleSeeDivergenceClick = () => navigate(ROUTES.DIVERGENCE_LIST)

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <Header title={t('CONTESTATIONS', 'Contestações')} />

      <div className="flex w-full max-w-[682px] flex-col items-center px-4 py-2">
        <img src={ErrorIcon} className="mb-6 w-36" />

        <span className="mb-2 block text-center text-xl font-bold text-error">
          {t(
            'UNEXPECTED_ERROR_CONTESTATION',
            'Um erro inesperado ocorreu ao enviar a sua contestação.'
          )}
        </span>

        <span className="mb-12 block text-center font-bold text-gray-500">
          {t('TRY_AGAIN_LATER_CONTESTATION', 'Tente novamente mais tarde.')}
        </span>

        <Button
          className="mb-4 w-full max-w-sm"
          onClick={handleSeeDivergenceClick}
        >
          {t('SEE_CONTESTATIONS', 'Ver contestações')}
        </Button>

        <Button
          className="w-full max-w-sm"
          styleType="outline"
          onClick={handleHomeClick}
          colored
        >
          {t('START', 'Início')}
        </Button>
      </div>
    </div>
  )
}

export default DivergenceErrorPage
